import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [done, setDone] = useState(false);
  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="card-soft p-8">
        <Link to="/" className="inline-block">
          <img
            src="/images/somm-logo.png"
            alt="Somm.ai"
            className="h-12 w-auto object-contain"
          />
        </Link>
        <h1 className="mt-6 text-3xl font-extrabold">Welcome back</h1>
        <p className="mt-2 text-[#4b5566]">Sign in to your Somm.ai account</p>
        {done ? (
          <div className="mt-8 p-4 rounded-lg bg-[#e8faef] text-[#16a34a] text-sm">Signed in (demo). Redirecting to app...</div>
        ) : (
          <form className="mt-8 space-y-4" onSubmit={(e) => { e.preventDefault(); setDone(true); }}>
            <input className="form-input" type="email" placeholder="Work email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <input className="form-input" type="password" placeholder="Password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2"><input type="checkbox"/> Remember me</label>
              <a href="#" className="text-[#22c55e] font-semibold">Forgot password?</a>
            </div>
            <button type="submit" className="btn-green w-full justify-center">Log in</button>
          </form>
        )}
        <div className="mt-6 text-sm text-[#4b5566] text-center">Don't have an account? <Link to="/meeting" className="text-[#22c55e] font-semibold">Schedule a demo</Link></div>
      </div>
    </div>
  );
}
